<template>
  <div id="permalink-page">
    <v-loading :isLoading="loading" color="#007be8"></v-loading>
    <div v-show="!loading" class="full-height">
      <iframe src="" frameborder="0" id="secure-iframe"></iframe>
      <div class="register-container" style="width: 355px;" v-show="!showSecureIframe">
        <div class="d-flex justify-content-center flex-column full-height font-montserrat">
          <span class="text-right">
              <img src="/static/assets/images/flag/en.png" class="cursor-pointer" @click.prevent="changeLang('en')">
              <img src="/static/assets/images/flag/fr.png" class="cursor-pointer" @click.prevent="changeLang('fr')">
          </span>
          <form @submit.prevent="submitCheckout()" method="post" id="paymentInfoForm" role="form" data-supermanager="form" _lpchecked="1">
            <input type="hidden" name="stripeToken" v-model="stripeToken"/>
            <input type="hidden" name="stripeEmail" v-model="stripeEmail"/>
            <span class="payment-errors"></span>
            <div id="panel-paiement-box" class="panel panel-default transaction-box">
              <div class="panel-header panel-product-header text-align-center">
                <div class="product-details">
                  <h5 class="product-name mb-0">
                    {{ user.first_name }} -  {{ user.last_name }} - {{ user.email }}
                  </h5>
                </div>
              </div>
              <div class="panel-body no-padding">
                <section id="cardBox" class="form-section form-card-section">
                  <h3 id="cardBoxTitle" class="form-section-label no-margin semi-bold">
                    {{ $t('payments.permalink.your_card') }}</h3>
                  <div class="card-container">
                    <img src="/static/assets/images/permalink/carts.png" class="not-applicable carts">
                  </div>
                  <div id="card-inputs">
                    <div class="card-element-container">
                      <div id="card-number"></div>
                      <i aria-hidden="true" class="fa fa-credit-card"></i>
                    </div>
                    <div class="row m-0">
                      <div class="card-element-container col-7 p-0">
                        <div class="row m-0">
                          <div class="col-11 p-0">
                            <div id="card-expiry"></div>
                            <i aria-hidden="true" class="fa fa-calendar"></i>
                          </div>
                        </div>
                      </div>
                      <div class="card-element-container col-5 ml-auto p-0">
                        <div id="card-cvc"></div>
                        <i aria-hidden="true" class="fa fa-unlock-alt"></i>
                      </div>
                    </div>
                  </div>
                  <input type="submit"
                         :disabled="paymentDisabled"
                         class="btn btn-block btn-primary button-submit"
                         :value="$t('input.register')">
                </section>
              </div>
            </div>
            <p class="transaction-secured">
              <i class="fa fa-lock" aria-hidden="true"></i>
              <span id="footerSecurity"> {{ $t("payments.permalink.transaction_secured") }} </span>
            </p>
          </form>
          <div class="d-block mt-20">
            <div class="d-inline-block">
              <img src="/static/assets/images/payment-link-images/cards.png" class="payment-secure-images" alt=""
                   width="" height="25">
            </div>
            <div class="d-inline-block middle-image">
              <img src="/static/assets/images/payment-link-images/europe.png" class="payment-secure-images" alt=""
                   width="" height="25">
            </div>
            <div class="d-inline-block">
              <img src="/static/assets/images/payment-link-images/signing-contract.jpg" class="payment-secure-images"
                   alt="" width="" height="25">
            </div>
          </div>
        </div>
      </div>
      <div v-show="error" class="register-container  sm-p-t-30" style="width: 355px;">
        <div class="d-flex justify-content-center flex-column full-height font-montserrat">
          <h3 class="text-align-center">{{ $t('payments.permalink.errors.payment_not_existing_anymore') }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../../mixins/mixin';
import cardConnectService from './../../../services/card-connect';

export default {
  name: 'CardConnect',
  data() {
    return {
      permalink: this.$route.params.permalink,
      stripeToken: null,
      stripeEmail: null,
      error: null,
      success: false,
      loading: false,
      payment: {},
      errorDataNotFound: false,
      paymentDisabled: false,
      checkoutUrl: process.env.API_LOCATION,
      stripe: null,
      elements: null,
      card: null,
      cardCvc: null,
      cardNumber: null,
      cardExpiry: null,
      paymentIntent: null,
      showSecureIframe: false,
      user: {}
    }
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue')
  },
  mixins: [mixin],
  async mounted() {
    const vm = this;
    this.loading = true;

    await cardConnectService.getConnectedStripeAccount(this, this.permalink);
    if (vm.elements) {
      this.loading = false;
      await this.initCardDetails();
    }
  },
  methods: {
    async submitCheckout() {
      let vm = this;
      vm.loading = false;
      vm.paymentDisabled = true;
      vm.stripe.createToken(vm.cardNumber).then(vm.stripeResponseHandler);
    },
    async stripeResponseHandler(response) {
      let vm = this;
      if (response.error) {
        let text = '';
        if (response.error.message) {
          if(response.error.message.match(/A network error has occurred/)) {
            text = vm.$t('payments.permalink.errors.network_error');
          } else if(response.error.message.match(/Your card number is incorrect/)) {
            text = vm.$t('payments.permalink.errors.card_number_incorrect');
          } else if(response.error.message.match(/Expired API Key/)) {
            text = vm.$t('payments.permalink.errors.expired_api_key');
          } else if(response.error.message.match(/Your card's expiration year is invalid/)) {
            text = vm.$t('payments.permalink.errors.exp_year');
          } else {
            text = response.error.message;
          }
        } else {
          text = vm.$t('payments.permalink.errors.contact_support');
        }
        toastr.error(text);
        vm.paymentDisabled = false;
      } else {
        vm.stripeToken = response.token.id;
        let data = {
          'stripeToken': this.stripeToken,
          'permalink': this.permalink
        };
        vm.paymentDisabled = true;
        await cardConnectService.createStripeCustomer(this, data);
      }
    },
    async initCardDetails() {
      const vm = this;

      const elementStyle = {
        base: {
          color: '#878787',
          lineHeight: '37px',
          fontSize: '18px',
          '::placeholder': {
            color: '#878787'
          }
        }
      };

      vm.cardNumber = vm.elements.create('cardNumber', {
        style: elementStyle,
        placeholder: 'Card number'
      });
      vm.cardNumber.mount('#card-number');
      vm.cardExpiry = vm.elements.create('cardExpiry', {
        style: elementStyle,
        placeholder: 'MM/AA'
      });
      vm.cardExpiry.mount('#card-expiry');
      vm.cardCvc = vm.elements.create('cardCvc', {
        style: elementStyle,
        placeholder: 'CVC'
      });
      vm.cardCvc.mount('#card-cvc');
    }
  }
}
</script>



// WEBPACK FOOTER //
// CardConnect.vue?1bfa42b2